import { Route } from 'vue-router';
import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import LoanStore from '@/loan/store';
import { LoanProjectionType } from '@/loan/enums/loan-projection-type';

const loanStore = getModule(LoanStore, store);

export const loanProjectionResolver = (type?: LoanProjectionType) =>
	async (to: Route): Promise<void> => {
		const { loanId } = to.params;
		const { loanDetails } = loanStore;

		const value = LoanProjectionType.TAKE_BACK
			? '0'
			: loanDetails?.recurringPayment?.minimum ?? '0';

		await loanStore.getAndSetProjection({
			loanId,
			query: type ? { property: type, value } : undefined,
		});
	};
